import { render, staticRenderFns } from "./DialogTransferencia.vue?vue&type=template&id=6587f12e&"
import script from "./DialogTransferencia.vue?vue&type=script&lang=js&"
export * from "./DialogTransferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports